/**
 * LoginMethodSelector — Toggle between PHONE and EMAIL login methods.
 *
 * Props:
 *   value     — "PHONE" | "EMAIL" 
 *   onChange  — (newValue) => void
 *   disabled  — boolean
 */
import React from 'react';
import { useTheme } from '../../theme/ThemeContext';

const METHOD_LABELS = {
  EMAIL: 'Email',
  PHONE: 'Phone',
  USERNAME: 'Username',
};

export default function LoginMethodSelector({ value, onChange, disabled, methods }) {
  const { theme } = useTheme();
  const isDark = theme.auth.containerBg === '#111827';

  // Use provided methods list or default to EMAIL + PHONE
  const methodList = (methods || ['EMAIL', 'PHONE']).map((m) => ({
    value: m,
    label: METHOD_LABELS[m] || m,
  }));

  return (
    <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
      {methodList.map((m) => {
        const isActive = value === m.value;
        return (
          <button
            key={m.value}
            type="button"
            disabled={disabled}
            onClick={() => onChange(m.value)}
            style={{
              flex: 1,
              padding: '10px 12px',
              fontSize: 13,
              fontWeight: isActive ? 600 : 500,
              letterSpacing: '0.1px',
              border: `2px solid ${isActive ? (isDark ? '#0d9488' : '#5eead4') : (isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.08)')}`,
              borderRadius: 8,
              cursor: disabled ? 'not-allowed' : 'pointer',
              background: isActive
                ? isDark
                  ? 'linear-gradient(135deg, rgba(13, 148, 136, 0.1) 0%, rgba(13, 148, 136, 0.03) 100%)'
                  : 'linear-gradient(135deg, rgba(15, 118, 110, 0.1) 0%, rgba(15, 118, 110, 0.03) 100%)'
                : isDark
                  ? 'rgba(255, 255, 255, 0.02)'
                  : 'rgba(0, 0, 0, 0.01)',
              color: isActive ? (isDark ? '#5eead4' : '#0f766e') : theme.auth.mutedText,
              transition: 'all 0.3s ease',
              opacity: disabled ? 0.6 : 1,
              boxShadow: isActive
                ? isDark
                  ? '0 0 10px rgba(13, 148, 136, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.05)'
                  : '0 0 6px rgba(15, 118, 110, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.3)'
                : 'none',
            }}
          >
            {m.label}
          </button>
        );
      })}
    </div>
  );
}
